module.exports = __webpack_public_path__ + "assets/img/us-chamber-of-commerce-foundation-light.0cd9a0e6.png";